<template>
    <div
    class="gst-booking-details-summary gst-septenary-border gst-rounded-xs gst-booking-details-summary--disabled px-2 py-4 mb-2"
    :class="$vuetify.breakpoint.mdAndUp ? 'flex-column' : 'flex-row'">
    <div
        class="gst-booking-details-summary__details u-position-relative d-flex flex-column justify-center d-md-block"
        :class="$vuetify.breakpoint.mdAndUp ? 'mx-n2 mt-n4 mb-0' : 'mr-4'">
        <BaseImage
            :src="hotelImageSrc.src"
            :fallback-src="hotelImageSrc.fallBack"
            :class="
                $vuetify.breakpoint.mdAndUp
                    ? 'gst-booking-details-summary__image'
                    : 'gst-booking-details-summary__image--width'
            " />
    </div>
    <div>
        <div
            class="d-flex"
            :class="
                $vuetify.breakpoint.mdAndUp
                    ? 'justify-space-between align-center wrap-reverse'
                    : 'flex-column-reverse align-start'
            ">
            <h5>{{ bookingHotelRoom.name }}</h5>
            <StarRating
                v-if="bookingHotelRoom"
                :value="bookingHotelRoom.award.rating"
                class="event-rating" />
        </div>

        <p>{{ addressFormatted }}</p>
        <p>{{ lengthStayTextFormatted }}</p>
        <p>
            {{ bookingHotelRoom.room.name }},
            {{ bookingHotel.accommodation.roomsCount }}
        </p>
    </div>
</div>
</template>

<script>
import StarRating from '@core/shared/components/misc/StarRating.vue';
import { IMAGE_SIZE } from '@tenant/app/utils/constants/imageData';
import { getImageByWidth, getImageModel } from '@tenant/app/utils/imageModelUtils';

export default {
    name: 'BookingDetailsSummary',
    components: {
        StarRating,
    },
    props: {
        bookingHotelRoom: {
            type: Object,
            default: () => ({}),
        },
        bookingHotel: {
            type: Object,
            default: () => ({}),
        }
    },
    i18nOptions: {
        namespaces: 'main',
        keyPrefix: 'modules.hotel.features.manageBooking.theManageBookingCheckout._components.bookingDetailsSummary',
    },
    computed: {
        addressFormatted() {
            return this.$options.filters.fullLocation(this.bookingHotelRoom.address);
        },
        lengthStayTextFormatted() {
            const stayText = this.$t('nightStay');
            const nightWithCount = this.$t('_common:terms.nightWithCount', {
                count: this.bookingHotel.accommodation.nights,
            });
            return `${stayText} ${nightWithCount}`;
        },
        hotelImageSrc() {
            const imageUrl = this.bookingHotelRoom.image.original.url;
            return {
                src: getImageByWidth(
                    IMAGE_SIZE.LARGE,
                    getImageModel(imageUrl)
                ),
                fallBack: getImageByWidth(
                    IMAGE_SIZE.ORIGINAL,
                    getImageModel(imageUrl)
                ),
            };
        }
    }
}
</script>


<style lang="scss" scoped>
@import '@scssMixins';
@import '@scssVariables';

.gst-booking-details-summary--disabled {
    opacity: 0.5;
}

.gst-booking-details-summary {
    h5 {
        line-height: line-height('xxxl');
        padding: theme-spacing(4, 0, 3, 0);
        font-weight: font-weight('large');
    }

    p {
        line-height: line-height('xxl');
        margin-bottom: theme-spacing(1);
        color: theme-color('tertiary');
        font-size: font-size('s');
        font-weight: font-weight('regular');
    }
    @include mobile-only {
        h5 {
            padding: theme-spacing(2, 0);
            font-size: font-size('s');
        }

        p {
            font-size: font-size('xxs');
        }
    }
    
    .gst-booking-details-summary__details {
        .gst-booking-details-summary__image {
            height: 215px;
        }

        .gst-booking-details-summary__image--width {
            height: 100px;
            width: 30vw;
        }
    }
}

</style>